const PricingItem = ({ Round, img, link }) => {
  return (
    <div className="col-lg-3 col-sm-6 col-xs-12">
      <a href={link}>
        <div className="pricing-item ">
          <h4> {Round}</h4>
          <div className="d-flex justify-content-center">
            <lottie-player
              src={img}
              background="transparent"
              speed="1"
              style={{ width: "140px", height: "140px" }}
              loop
              autoplay
            ></lottie-player>
          </div>

          {/* <span>1 ETH = 500 Token</span> */}
          {/* <div className="pricing">15,000,000 Token</div> */}
          {/* {link === null ? null : <label>Click To View</label>} */}
          <label>Click To View</label>
        </div>
      </a>
    </div>
  );
};

export default PricingItem;
